import { GET_OFFERS, OFFERS_RECEIVED, SET_LOADING } from './constants';

/**
 *
 * @returns {{type: *}}
 */
export const getOffers = () => ({
  type: GET_OFFERS,
});

/**
 *
 * @param offers
 * @param total
 * @returns {{offers: *, total: *, type: *}}
 */
export function offersLoaded(offers, total) {
  return {
    type: OFFERS_RECEIVED,
    offers,
    total,
  };
}

/**
 *
 * @param loading
 * @returns {{type: string, loading: boolean}}
 */
export function setLoading(loading) {
  return {
    type: SET_LOADING,
    loading,
  };
}
